import { Engine } from './Engine'
import {Clock} from 'three'

export class RenderLoop {
  private clock: Clock
  public deltaTime = 16
  public currentTime = 0
  private animationId = 0

  constructor(private engine: Engine) {
    this.clock = new Clock()
    window.requestAnimationFrame(() => this.update())
  }

  update() {
    const step = () => {
      this.animationId = requestAnimationFrame(step)
      const elapsedTime = this.clock.getElapsedTime()

      this.deltaTime = elapsedTime - this.currentTime

      this.currentTime = elapsedTime

      this.engine.update(this.deltaTime)

    }
    step()
  }

  dispose() {
    window.cancelAnimationFrame(this.animationId)
  }
}
